<div class="page">
  <h1 class="title">{{ "orders-dashboard.title" | translate }}</h1>
  <div fxLayout="column">
    <form fxFlex="100" fxLayout="column" fxLayoutAlign="space-between stretch" [formGroup]="orderForm"
          #form="ngForm">
      <div class="row1">
        <mat-form-field fxFlex="20" appearance="outline">
          <mat-label>{{ "orders-dashboard.orderNumber" | translate }}</mat-label>
          <input formControlName="orderNumber" name="orderNumber" matInput/>
        </mat-form-field>

        <mat-form-field fxFlex="20" appearance="outline">
          <mat-label>{{ "orders-dashboard.projectType" | translate }}</mat-label>
          <mat-select formControlName="projectType" name="projectType">
            <mat-option value="Projeto">{{ "orders-dashboard.project" | translate }}</mat-option>
            <mat-option value="Spot">{{ "orders-dashboard.spot" | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="20" appearance="outline">
          <mat-label>{{ "orders-dashboard.projectDescription" | translate }}</mat-label>
          <input formControlName="projectDescription" name="projectDescription" matInput/>
        </mat-form-field>

        <mat-form-field fxFlex="20" appearance="outline">
          <mat-label>{{ "orders-dashboard.requestDate" | translate }}</mat-label>
          <input formControlName="requestDate" name="requestDate" type="text" matInput [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker [calendarHeaderComponent]="customHeader" #picker></mat-datepicker>
        </mat-form-field>
        @if (!this.authenticationService.isRequester) {
          <mat-form-field appearance="outline" fxFlex="25">
            <mat-label>{{ "orders-dashboard.requester" | translate }}</mat-label>
            <input formControlName="requester" name="requester" type="text" data-cy-input="model" matInput
                   [matAutocomplete]="userAutocomplete">
            <mat-autocomplete #userAutocomplete="matAutocomplete" [displayWith]="showName">
              <mat-option *ngFor="let user of filteredUsers" [value]="user">
                {{ user.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        }
        <mat-form-field fxFlex="20" appearance="outline">
          <mat-label>{{ "orders-dashboard.status" | translate }}</mat-label>
          <mat-select formControlName="status" name="status">
            @if(this.authenticationService.isApproverBudgets){
            <mat-option value="WAITING_BUDGET_APPROVAL">{{ "status.waiting-budget-approval" | translate }}</mat-option>
            <mat-option value="FINISHED">{{ "status.finished" | translate }}</mat-option>
            <mat-option value="CANCELLED">{{ "status.cancelled" | translate }}</mat-option>
            }@else {
            @if(this.authenticationService.isRequester){
              <mat-option value="NOT_SENT">{{ "status.not-sent" | translate }}</mat-option>
            }
            <mat-option value="WAITING_REQUEST_APPROVAL">{{ "status.waiting-request-approval" | translate }}</mat-option>
            <mat-option value="WAITING_BUDGET_REQUEST_SUBMISSION">{{ "status.waiting-budget-request-submission" | translate }}
            </mat-option>
            <mat-option value="WAITING_SUPPLIERS_RESPONSE">{{ "status.waiting-suppliers-response" | translate }}
            </mat-option>
            <mat-option value="WAITING_BUDGET_APPROVAL">{{ "status.waiting-budget-approval" | translate }}</mat-option>
            <mat-option value="FINISHED">{{ "status.finished" | translate }}</mat-option>
            <mat-option value="REJECTED">{{ "status.rejected" | translate }}</mat-option>
            <mat-option value="CANCELLED">{{ "status.cancelled" | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row2">
        <button
          (click)="resetForm()"
          mat-flat-button color="primary" class="add-button mg-b-22"
          [disabled]="!orderForm.dirty"
        >
          {{ "button.clean" | translate }}
        </button>
        <button mat-flat-button color="primary" class="add-button mg-b-22" [disabled]="!orderForm.valid"
                (click)="filterItems()">
          {{ "button.filter" | translate }}
        </button>
      </div>
    </form>
  </div>
  <div class="orders-dashboard-container">
    <table mat-table [dataSource]="tableData">
      <ng-container matColumnDef="orders">
        <th class="table-header" mat-header-cell *matHeaderCellDef [style.width]="columnWidths['orders']">
          {{ "orders-dashboard.order" | translate }}
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.id }}</td>
      </ng-container>

      <ng-container matColumnDef="projectType">
        <th class="table-header" mat-header-cell *matHeaderCellDef [style.width]="columnWidths['projectType']">
          {{ "orders-dashboard.projectType" | translate }}
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.projectType }}</td>
      </ng-container>

      <ng-container matColumnDef="projectDescription">
        <th class="table-header" mat-header-cell *matHeaderCellDef [style.width]="columnWidths['projectDescription']">
          {{ "orders-dashboard.projectDescription" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="table-cell"> {{ element.projectDescription }}</td>
      </ng-container>

      <ng-container matColumnDef="requestDate">
        <th class="table-header" mat-header-cell *matHeaderCellDef [style.width]="columnWidths['requestDate']">
          {{ "orders-dashboard.requestDate" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.requestDate | date:'dd/MM/yyyy - HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="purchaseDate">
        <th class="table-header" mat-header-cell *matHeaderCellDef [style.width]="columnWidths['purchaseDate']">
          {{ "orders-dashboard.purchaseDate" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.purchaseDate ? (element.purchaseDate | date:'dd/MM/yyyy - HH:mm') : '-' }}
        </td>
      </ng-container>

      @if (!this.authenticationService.isRequester) {
        <ng-container matColumnDef="requester">
          <th class="table-header" mat-header-cell *matHeaderCellDef [style.width]="columnWidths['requester']">
            {{ "orders-dashboard.requester" | translate }}
          </th>
          <td mat-cell *matCellDef="let element"> {{ element.requesterName }}</td>
        </ng-container>
      }

      <ng-container matColumnDef="status">
        <th class="table-header" mat-header-cell *matHeaderCellDef [style.width]="columnWidths['status']">
          {{ "orders-dashboard.status" | translate }}
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.statusDisplay }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th class="table-header action" mat-header-cell *matHeaderCellDef [style.width]="columnWidths['action']">
          {{ "orders-dashboard.action" | translate }}
        </th>
        <td mat-cell class="action" *matCellDef="let element">
          <div [ngClass]="{'center-single-icon': authenticationService.isApproverBudgets || authenticationService.isRequester}" fxLayout="row">
            <button mat-icon-button (click)="navigateToDetails(element)" class="table-icons"
                    matTooltip="{{'button.view-tooltip' | translate}}">
              <mat-icon>visibility</mat-icon>
            </button>
            @if (this.showRequesterButtons) {
              <button mat-icon-button class="table-icons remove"
                      (click)="deleteOrder(element)"
                      matTooltip="{{'button.delete-tooltip' | translate}}"
                      [disabled]="disableRequesterAction(element)">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-icon-button class="table-icons"
                      (click)="navigateToEditOrder(element)"
                      matTooltip="{{'button.edit-tooltip' | translate}}"
                      [disabled]="disableRequesterAction(element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="table-icons"
                      (click)="sendOrder(element)"
                      matTooltip="{{'button.send-tooltip' | translate}}"
                      [disabled]="disableRequesterAction(element)">
                <mat-icon>send</mat-icon>
              </button>
            }
            @if (this.showApprovalButtons) {
              <button mat-icon-button (click)="approveOrder(element)" class="table-icons"
                      matTooltip="{{'button.approve-tooltip' | translate}}"
                      [disabled]="disableApprovalApproveReject(element)">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button (click)="rejectOrder(element)" class="table-icons"
                      matTooltip="{{'button.reject-tooltip' | translate}}"
                      [disabled]="disableApprovalApproveReject(element)">
                <mat-icon>closed</mat-icon>
              </button>
              <button mat-icon-button class="table-icons remove"
                      (click)="deleteOrder(element)"
                      matTooltip="{{'button.delete-tooltip' | translate}}"
                      [disabled]="disableApprovalEditDelete(element)">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-icon-button class="table-icons"
                      (click)="navigateToEditOrder(element)"
                      matTooltip="{{'button.edit-tooltip' | translate}}"
                      [disabled]="disableApprovalEditDelete(element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="table-icons"
                      (click)="cancelOrder(element)"
                      matTooltip="{{'button.cancel' | translate}}"
                      [disabled]="disableCancelAction(element)">
                <mat-icon>cancel</mat-icon>
              </button>
            }
            @if (this.authenticationService.isApproverBudgets) {
              <button mat-icon-button class="table-icons"
                      (click)="cancelOrder(element)"
                      matTooltip="{{'button.cancel' | translate}}"
                      [disabled]="disableCancelAction(element)">
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </div>
  <mat-paginator
    [length]="pageable.length"
    [pageSize]="pageable.pageSize"
    (page)="pageChange($event)"
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons>
  </mat-paginator>
</div>
<app-breadcrumbs [breadcrumbsData]="breadcrumbsData"></app-breadcrumbs>
